import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { Menu, Segment } from 'semantic-ui-react';
import { qarManagersMenuOptions } from '../../helper/constants';

const QarManagersOptionsMenu = (props) => {

    const [selectedOption, setSelectedOption] = useState("viewAllReviews")

    const setActiveItem = (item) => {
        setSelectedOption(item);
        props.updateActiveItem(item);
    }
    return (
        <div className='qar-manager-options-menu'>
            <Segment>
                <Menu pointing vertical size={'small'}>
                    <Menu.Item as={Button}
                        name='View All Reviews'
                        onClick={() => setActiveItem(qarManagersMenuOptions.viewAllReviews)}
                        active={selectedOption === qarManagersMenuOptions.viewAllReviews}

                    />
                    <Menu.Item as={Button}
                        name='View All Accounts in review'
                        onClick={() => setActiveItem(qarManagersMenuOptions.viewAllEmployees)}
                        active={selectedOption === qarManagersMenuOptions.viewAllEmployees}
                    />
                    {props.shouldRenderChameleonAdminEmployeeReviews ? <Menu.Item as={Button}
                        name='View Chameleon Admins'
                        onClick={() => setActiveItem(qarManagersMenuOptions.viewChameleonAdmins)}
                        active={selectedOption === qarManagersMenuOptions.viewChameleonAdmins}
                    /> : <></>}
                        <Menu.Item as={Button}
                        name='Not Recognized Accounts In Review'
                        onClick={() => setActiveItem(qarManagersMenuOptions.viewUnmatchedAccountsInReview)}
                        active={selectedOption === qarManagersMenuOptions.viewUnmatchedAccountsInReview}
                    />
                    <Menu.Item as={Button}
                        name='View All Findings in review'
                        onClick={() => setActiveItem(qarManagersMenuOptions.viewAllFindings)}
                        active={selectedOption === qarManagersMenuOptions.viewAllFindings}
                    />
                    <Menu.Item as={Button}
                        name='View All Delegated Employees'
                        onClick={() => setActiveItem(qarManagersMenuOptions.viewAllDelegatedEmployees)}
                        active={selectedOption === qarManagersMenuOptions.viewAllDelegatedEmployees}
                    />
                </Menu>
            </Segment>
        </div>
    );
};

export default QarManagersOptionsMenu;